<section class="main-section">
    <app-dialog-header [title]="data.data.edit ? 'Edit Log Call' : 'Log Call'" (close)="cancel()"></app-dialog-header>
    <div class="input-field-section">
        <div class="input-box" *ngIf="data.data.type == 'ALL_CALLS'">
            <div class="input-label">Call for <span class="required">*</span></div>
            <div class="lead-section">
                <div class="field-dd type-dd" [class.open]="openDropdown === 'participantType'">
                    <button type="button" class="field-dd-trigger" (click)="toggleDropdown('participantType')">
                        <span>{{ getParticipantTypeLabel() }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <div class="field-dd-panel" *ngIf="openDropdown === 'participantType'">
                        <div class="field-dd-row" *ngFor="let item of type; trackBy: trackByOptionValue"
                            [class.selected]="participantType === item.value" (click)="selectParticipantType(item.value)">
                            {{ item.viewValue }}
                        </div>
                    </div>
                </div>
                <div class="field-dd contact-dd">
                    <input type="text" placeholder="Search by name" class="custom-input" [(ngModel)]="selectedContact"
                        [formControl]="myControl" (ngModelChange)="searchContact()" (focus)="openContactDropdown()">
                    <div class="field-dd-panel" *ngIf="openDropdown === 'contact'">
                        <div class="field-dd-row" *ngFor="let option of options"
                            (mousedown)="contactSelected(option); closeDropdowns(); $event.preventDefault()">
                            {{ option.personalInfo.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="input-box" *ngIf="selectedContact">
            <div class="input-label">Assign To</div>
            <div class="field-dd" [class.open]="openDropdown === 'assignedTo'"
                [class.disabled]="!filteredStaffList.length || filteredStaffList.length === 1">
                <button type="button" class="field-dd-trigger"
                    (click)="(filteredStaffList.length > 1) && toggleDropdown('assignedTo')">
                    <span>{{ callDetails.assignedName || 'Select Staff' }}</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div class="field-dd-panel" *ngIf="openDropdown === 'assignedTo'">
                    <input type="text" class="field-dd-search" placeholder="Search staff" [(ngModel)]="staffSearch"
                        (ngModelChange)="filterStaff()" autocomplete="off">
                    <div class="field-dd-row" *ngFor="let staff of filteredStaffList"
                        [class.selected]="callDetails.assignedTo === staff.id"
                        (click)="selectAssignedTo(staff); closeDropdowns()">
                        {{ staff.name }}
                    </div>
                </div>
            </div>
            <div class="d-flex mt-1 align-items-center justify-content-start"
                *ngIf="pipeLineName != 'Default Pipeline' && pipeLineName != ''">
                <span style="font-size:10px" class="text-danger">This Staff List is based on {{pipeLineName}} pipeline</span>
            </div>
        </div>

        <div class="input-box">
            <div class="input-label">Type of Call</div>
            <div class="radio-pill-row">
                <div class="radio-pill" [class.selected]="callDetails.call_variant === 'SCHEDULE'" (click)="setCallVariant('SCHEDULE')">
                    <span class="radio-dot"></span>Schedule
                </div>
                <div class="radio-pill" [class.selected]="callDetails.call_variant === 'LOG'" (click)="setCallVariant('LOG')">
                    <span class="radio-dot"></span>Log
                </div>
            </div>
        </div>

        <div class="input-box-full">
            <div class="input-label">Title <span class="required">*</span></div>
            <input class="custom-input" placeholder="Enter subject" [(ngModel)]="callDetails.title">
        </div>

        <div class="input-box-full">
            <div class="input-label">Number <span class="required">*</span></div>
            <input class="custom-input" placeholder="Enter Number" disabled [(ngModel)]="callDetails.leadNumber">
        </div>

        <div class="two-col-row">
            <div class="input-box">
                <div class="input-label">Call Start Time <span class="required">*</span></div>
                <div class="field-dd" [class.open]="openDropdown === 'startDate'">
                    <button type="button" class="field-dd-trigger" (click)="openCallStartPicker()">
                        <span>{{ getCallStartLabel() }}</span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                    </button>
                    <app-custom-calendar *ngIf="openDropdown === 'startDate'" mode="single" [showTime]="true"
                        align="left" [selectedDate]="startDateAsDate" [minDate]="minDateAsDate"
                        (dateChange)="onCallStartApplied($event)" (cancel)="closeDropdowns()">
                    </app-custom-calendar>
                </div>
            </div>
            <div class="input-box" *ngIf="callDetails.call_variant == 'LOG'">
                <div class="input-label">Call Duration</div>
                <input class="custom-input" placeholder="In Minutes" [(ngModel)]="callDetails.callDuration">
            </div>
        </div>

        <div class="input-box">
            <div class="input-label">Call Type <span class="required" *ngIf="callDetails.call_variant != 'SCHEDULE'">*</span></div>
            <div class="field-dd" [class.open]="openDropdown === 'callType'" [class.disabled]="callDetails.call_variant === 'SCHEDULE'">
                <button type="button" class="field-dd-trigger" [disabled]="callDetails.call_variant === 'SCHEDULE'"
                    (click)="toggleDropdown('callType')">
                    <span>{{ getCallTypeLabel() }}</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div class="field-dd-panel" *ngIf="openDropdown === 'callType'">
                    <div class="field-dd-row" *ngFor="let item of callTypes; trackBy: trackByOptionValue"
                        [class.selected]="callDetails.callType === item.value" (click)="selectCallType(item.value)">
                        {{ item.viewValue }}
                    </div>
                </div>
            </div>
        </div>

        <div class="input-box">
            <div class="input-label">Call Status</div>
            <div class="field-dd" [class.open]="openDropdown === 'callStatus'">
                <button type="button" class="field-dd-trigger" (click)="toggleDropdown('callStatus')">
                    <span>{{ getCallStatusLabel() }}</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div class="field-dd-panel" *ngIf="openDropdown === 'callStatus'">
                    <div class="field-dd-row" *ngFor="let item of status; trackBy: trackByOptionValue"
                        [class.selected]="callDetails.callStatus === item.value" (click)="selectCallStatus(item.value)">
                        {{ item.viewValue }}
                    </div>
                </div>
            </div>
        </div>

        <div class="input-box" *ngIf="callDetails.call_variant == 'SCHEDULE'">
            <div class="input-label">Reminder</div>
            <div class="field-dd" [class.open]="openDropdown === 'reminder'">
                <button type="button" class="field-dd-trigger" (click)="toggleDropdown('reminder')">
                    <span>{{ getReminderLabel() }}</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div class="field-dd-panel" *ngIf="openDropdown === 'reminder'">
                    <div class="field-dd-row" *ngFor="let item of hourReminder; trackBy: trackByOptionValue"
                        [class.selected]="callDetails.remainder === item.value" (click)="selectReminder(item.value)">
                        {{ item.viewValue }}
                    </div>
                </div>
            </div>
        </div>

        <div class="input-box">
            <div class="input-label">Call Purpose</div>
            <div class="field-dd" [class.open]="openDropdown === 'callPurpose'">
                <button type="button" class="field-dd-trigger" (click)="toggleDropdown('callPurpose')">
                    <span>{{ getCallPurposeLabel() }}</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div class="field-dd-panel" *ngIf="openDropdown === 'callPurpose'">
                    <div class="field-dd-row" *ngFor="let item of callPurpose; trackBy: trackByOptionValue"
                        [class.selected]="callDetails.callPurpose === item.value" (click)="selectCallPurpose(item.value)">
                        {{ item.viewValue }}
                    </div>
                </div>
            </div>
        </div>

        <div class="input-box-full" *ngIf="callDetails.callPurpose === 'OTHERS'">
            <div class="input-label">Other Reason <span class="required">*</span></div>
            <input class="custom-input" placeholder="Enter Reason" [(ngModel)]="callDetails.otherReason">
        </div>

        <div class="description">
            <div class="input-label">Notes</div>
            <textarea class="text-box" placeholder="Enter description here" cols="30" rows="5"
                [(ngModel)]="callDetails.description"></textarea>
        </div>

        <div class="description">
            <div class="input-label">Labels</div>
            <app-crm-label-picker
                [labelIds]="selectedLabelIds"
                [labels]="selectedLabels"
                (labelIdsChange)="onSelectedLabelIdsChange($event)"
                (labelsChange)="onSelectedLabelsChange($event)"
            ></app-crm-label-picker>
        </div>
    </div>

    <app-dialog-footer
        [submitLabel]="data.data.edit ? 'Update Call' : 'Create Call'"
        [submitDisabled]="data.data.edit ? editDisabled : createDisabled"
        [loading]="data.data.edit ? updateLoader : createLoader"
        (cancel)="cancel()"
        (submit)="data.data.edit ? editCall() : createCall()">
    </app-dialog-footer>
</section>
